'use strict';

require('../modules/forms/forms');
require('../helpers/show-modal-message/show-modal-message');

angular.module('far.forms.discountServiceForm', ['dekky.forms', 'far.helpers.showModalMessage'])
    .service('discountServiceForm', function (form, fileUploadFilters, showModalMessage) {
        var discountServiceModel = form('discountServiceModel');
        discountServiceModel
            .addField('name', null, {
                validators: {required: true},
                label: 'Название',
                options: {placeholder: 'Название'}
            })
            .addField('link', null, {
                validators: {required: true},
                label: 'Ссылка (указывать с протоколом http://)',
                options: {placeholder: 'Ссылка - например, https://alpfederation.ru'}
            })
            .addField('description', 'textarea', {
                label: 'Описание',
                options: {
                    redactor: true,
                    placeholder: 'Описание'
                }
            })
            .addField('image', 'imageUpload', {
                label: 'Загрузить изображение',
                uploader: {
                    url: Routing.generate('api_upload_post_image'),
                    filters: [
                        fileUploadFilters.fileSize()
                    ],
                    autoUpload: true,
                    removeAfterUpload: true,
                    onWhenAddingFileFailed: function (item, filter) {
                        var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
                        showModalMessage(message);
                    }
                }
            });
        return discountServiceModel;
    });
